<!-- Panel izquierda -->
<app-header
    [sub_titulo]="EsEdicion? 'Administrador menú - Editando asistente' : 'Administrador menú - Nuevo asistente'"></app-header>

<mat-card style="background-color: #f8f8ff; width: 100%; height: auto">
    <div id="menus" style="min-height: 95vh; height: auto">
        <div class="card-body-content" style="width: 99%; min-height: 90%; max-height: 99%; height: 90%">
            <br />
            <mat-card style="height: 99%">
                <div class="nuevo-asistente-container">
                    <div class="form-group">
                        <app-campo-default-admin descripcion_etiqueta="Código (*)"
                            placeholder_input="Este campo es obligatorio" [(ngModel)]="codigoAsistente">
                        </app-campo-default-admin>
                    </div>

                    <div class="form-group">
                        <app-campo-default-admin descripcion_etiqueta="Nombre (*)"
                            placeholder_input="Este campo es obligatorio" [(ngModel)]="nombre">
                        </app-campo-default-admin>
                    </div>

                    <div class="form-group">
                        <app-campo-default-admin descripcion_etiqueta="Descripción (*)"
                            placeholder_input="Este campo es obligatorio" [(ngModel)]="descripcion">
                        </app-campo-default-admin>
                    </div>

                    <div class="form-field-align" *ngIf="this.EsEdicion">
                        <label for="habilitado">Habilitado (*)</label>
                        <mat-slide-toggle [(ngModel)]="habilitado"></mat-slide-toggle>
                    </div>

                    <div class="form-group" *ngIf="esUsuarioAdminitrador">
                        <app-campo-default-admin id="areaFuncional" name="areaFuncional"
                            descripcion_etiqueta="Área Funcional (*)" placeholder_input="" [(ngModel)]="areaFuncional">
                        </app-campo-default-admin>
                    </div>

                    <div class="form-group" *ngIf="!esUsuarioAdminitrador">
                        <app-generic-select [options]="myOptionsAreasFunciones" placeholder="Área Funcional (*)"
                            [(ngModel)]="areaFuncional">
                        </app-generic-select>
                    </div>

                    <app-mensaje-error *ngIf="error" [mensaje_error]="error"></app-mensaje-error>
                    <div class="fin">
                        <app-boton-primario [disabled]="loading" [spinner]="loading"
                            [boton_texto]="loading ? 'Guardando' : 'Guardar'" (boton_funcion)="applyOperation()"
                            titulo="Guardar asistente menú"></app-boton-primario>
                        <button mat-raised-button 
                                (click)="irPaginaInicio()">Cancelar</button>
                    </div>
                </div>
            </mat-card>
        </div>
    </div>
</mat-card>